import { sortDates } from "../sortDates";
import { getBookingDate } from "../getBookingDate";

export const formatRevenueChartData = (
  bookedBookings,
  cancelledBookings,
  dataMode
) => {
  const bookedByDate = bookedBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    acc[date] = (acc[date] || 0) + booking.totalamount;
    return acc;
  }, {});
  const cancelledByDate = cancelledBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    acc[date] = (acc[date] || 0) + booking.totalamount;
    return acc;
  }, {});

  const labels = sortDates([
    ...new Set([...Object.keys(bookedByDate), ...Object.keys(cancelledByDate)]),
  ]);
  const bookedData = labels.map((date) => Number(bookedByDate[date] || 0));
  const cancelledData = labels.map((date) =>
    Number(cancelledByDate[date] || 0)
  );

  return {
    labels,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(255, 159, 64, 0.6)",
        borderColor: "rgba(255, 159, 64, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };
};
